export default __webpack_public_path__ + "static/media/2-1-1024x622.f6470352.png";